import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/itunes': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M223.6 80.3c94.5 0 171.2 76.7 171.2 171.3 0 94.5-76.6 171.2-171.2 171.2-94.6 0-171.1-76.8-171.1-171.3s76.5-171.2 171.1-171.2zM303 320.3c1.4-6.2 0.9 3 1-167.6 0-5.7-3.3-9.1-9-8.7-1.8 0-14.1 2.4-115.1 21.4-0.9 0-4.6 1-6.7 2.7-2 1.6-3.1 3.8-3.5 6.4-1.7 6.7 2.4 128-2.6 133.7-2.1 2.5-4.7 3.2-7.7 3.7-17.7 3.2-29.6 4.8-38 12.8-14.5 14.2-7 38.9 14.4 42.9 8 1.4 23.1-0.6 31.4-5.2 7.3-3.8 12.8-10.6 14.9-19.6 1.7-7.7 1.2-2.4 1.2-118.5 0-5.7 1.7-7.2 6.7-8.3 0 0 87.9-16.4 91.9-17.1 5.7-1 8.4 0.5 8.4 6.1 0 78.8 1 77.2-2.2 80.8-2.1 2.5-4.7 3.2-7.7 3.7-17.7 3.2-29.6 4.8-38 12.8-10.6 10.4-10.4 26.8 1.4 36.8 9.7 7.8 19.8 7.2 31.9 5 13.8-2.6 24.1-10.2 27.3-23.8zM345.2 32c56.9 0 102.8 45.9 102.8 102.8v242.4c0 56.9-45.8 102.8-102.8 102.8h-242.4c-56.9 0-102.8-45.9-102.8-102.8v-242.4c0-56.9 45.9-102.8 102.8-102.8h242.4zM223.6 444c106.3 0 192.5-86.2 192.5-192.5s-86.2-192.5-192.5-192.5c-106.3 0-192.5 86.2-192.5 192.5s86.2 192.5 192.5 192.5z'
      }
    ]
  }
})
